function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import { defaultBreakpoints, ScreenSize } from '../../theme/screen-sizes';
import { ScreenSizeContext } from './screen-size-context';
/**
 * Returns a {@link ScreenSize} literal based on the size of the
 *   screen.
 *
 * @param windowWidth Window width
 * @param breakpoints Breakpoints for the current UI
 */

var determineScreenSize = function determineScreenSize(windowWidth, breakpoints) {
  if (windowWidth <= breakpoints[ScreenSize.xsmall]) {
    return ScreenSize.xsmall;
  }

  if (windowWidth <= breakpoints[ScreenSize.small]) {
    return ScreenSize.small;
  }

  if (windowWidth <= breakpoints[ScreenSize.medium]) {
    return ScreenSize.medium;
  }

  return ScreenSize.large;
};
/**
 * Context provider for ScreenSize. When added to the DOM, all of its
 *   children will be able to use the {@link useScreenSize} hook to
 *   access the current size of the screen.
 *
 * It does this by adding an effect that will manage a window resize
 *   event listener.
 *
 * @param props - custom properties with children.
 */


export var ScreenSizeProvider = function ScreenSizeProvider(props) {
  // if no breakpoints are provided, use component-lib theme defaults
  var breakpoints = props.breakpoints || defaultBreakpoints;

  var _useState = useState(determineScreenSize(breakpoints[1], breakpoints) // use mobile breakpoint as default for smallest layout shift & snappier experience on mobile
  ),
      _useState2 = _slicedToArray(_useState, 2),
      screenSize = _useState2[0],
      setScreenSize = _useState2[1];

  useEffect(function () {
    // Define the window event listener.
    var handleResize = function handleResize() {
      // Determine the size
      var size = determineScreenSize(window.innerWidth, breakpoints); // Update the context.

      setScreenSize(size);
    };

    handleResize(); // Attach the event listener

    window.addEventListener('resize', handleResize);
    return function () {
      // Unattach the event listener if this element is removed
      window.removeEventListener('resize', handleResize);
    };
  }, [breakpoints]);
  return /*#__PURE__*/React.createElement(ScreenSizeContext.Provider, _extends({
    value: screenSize
  }, props));
};